module.exports = __webpack_public_path__ + "img/lights_m.1f876566.png";